<template>
    <div class="d-inline-block">
        <div class="dropdown">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="columnFilterDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-columns" aria-hidden="true"></i> Columns
            </button>
            <div class="dropdown-menu" aria-labelledby="columnFilterDropdown" onclick="event.stopPropagation()">
                <div v-for="column, index in columns" :key="index" class="px-3">
                    <input type="checkbox" :id="'filter' + index" :value="column.tag" v-model="checkedFilters">
                    <label :for="'filter' + index" class="ml-2 mb-0">{{ column.name }}</label>
                </div>
            </div>
        </div>

        <component :is="'style'" v-for="tag, index in checkedFilters" :key="index">
            [data-column="{{ tag }}"] {
                display: table-cell !important;
            }
        </component>
    </div>
</template>

<script>
export default {
    props: {
        savedColumns: { type: Array, required: true},
        columns: { type: Array, required: true},
        name: { type: String, required: true}
    },
    data() {
        return {
            checkedFilters: [],
        }
    },
    mounted() {
        if(this.$props.savedColumns.length > 0) {
            this.checkedFilters = this.$props.savedColumns;
        } else {
            this.checkedFilters = this.columns.map(column => column.tag);
        }
    },
    watch: {
        checkedFilters(newValue) {
            let params = {};
            params.key = 'column-filter-' + this.name;
            params.columns = JSON.stringify(newValue);

            axios.post('/api/save-columns', params).catch(error => {
                console.log(error);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
    min-width: 12rem;
    left: -81px !important;
    z-index: 9999;
    @media screen and (max-width: 575px) {
        left: 0!important;
    }
}
</style>